<template>
  <el-button type="danger"
             size="mini"
             :disabled="batchid < 1"
             @click="onSubmit">
    <slot></slot>
  </el-button>
</template>

<script>

export default {
  components: {},
  props: {
    batchid: String,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.order.options,
    }),
    search () {
      return this.searchValue
    },
  },
  methods: {
    onSubmit () {
      this.$confirm('是否按批次通过工单?', '操作确认', {}).then(() => {
        this.passByBatchId()
      }).catch(action => {
        console.log('取消按批次批量通过操作')
      })
    },
    passByBatchId () {
      return request.alert('onBatchSuccceed', {batchid: this.batchid}).then((res) => {
        this.$message({
          showClose: true,
          message: '按批次批量通过成功,请前往批量任务查看',
          type: 'success',
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/order/components/buttons/OrderOnBatchSucceedButton.vue